import Vue from 'vue'
import QueryString from "querystring";
import {APIHOST} from "@/settings/server";
import $store from "../store";
import axios from "axios";

class AuthService {
    constructor() {
        this.cancelTokenSource = axios.CancelToken.source();
    }

    cancelRequests() {
        this.cancelTokenSource.cancel('GET requests canceled by the user.');
        this.cancelTokenSource = axios.CancelToken.source();
    }

    auth({username, password}) {
        return Vue.axios.post(`${APIHOST}/token`, QueryString.stringify({
            grant_type: "password",
            username: username,
            password: password
        }));
    }

    getLogin() {
        return Vue.axios.get(`${APIHOST}/api/login`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }
}

export default new AuthService()